import { Outlet } from "react-router-dom";
import { CContainer, CSpinner } from "@coreui/react";
import { Suspense, useEffect, useState, useContext } from "react";
import clsx from "classnames";
import style from "./PartnersLayout.module.css";
import PartnersSideBar from "./front/PartnersSideBar";
import PartnersHeader from "./front/PartnersHeader";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { requester } from "App";
import { use } from "react";

function PartnersLayout() {
    const [isMounted, setMounted] = useState();
    const { isMobile } = useContext(BrowserDetectContext);
    const [stores, setStores] = useState([]);

    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        if (isMounted) {
            fetchStores();
        }
    }, [isMounted]);

    const fetchStores = async () => {
        await requester.findAllStoresByVendorUserName((result) => {
            setStores(result.data);
            console.log("setStores : ",result.data)
        });
    }

    return (
        <>
            {
                isMounted &&
                <div style={{ width: "max-content", minWidth: "100%" }}>
                    <PartnersSideBar />
                    <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                        <PartnersHeader />
                        <div className={clsx("body flex-grow-1 px-3", style.layout)} >
                            <CContainer lg>
                                <div className={clsx(style.outletContainer, { [style.desktop]: !isMobile })}>
                                    <div className={style.outlet}>
                                        <Suspense fallback={<CSpinner color="primary" />}>
                                            <Outlet context={{ stores }} />
                                        </Suspense>
                                    </div>
                                </div>
                            </CContainer>
                        </div>
                        {/* <ManagerFooter /> */}
                    </div>
                </div>
            }
        </>
    );
}

export default PartnersLayout;
